import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/fonts/icons.js'
import DrawerLayout from 'vue-drawer-layout'
import './services/GlobalVariables'
import './services/ProxyHandler'
import VueVirtualScroller from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import VueToggles from 'vue-toggles';
import Loading from 'vue-loading-overlay';
import vSelect from 'vue-select'
import "vue-select/dist/vue-select.css";
import {VueEditor} from "vue2-editor";
import OneSignalVue from 'onesignal-vue'

Vue.use(OneSignalVue);
import {migrateLegacyVuexState} from './services/migrateOldState';
import { initTabGuardLeader } from './services/tabGuardLeader';
import { startBatchTimer } from './composables/useAppUsage';


// Import stylesheet

import 'vue-loading-overlay/dist/vue-loading.css';
import VueBarcodeScanner from 'vue-barcode-scanner'

let options = {
    sensitivity: 100, // default is 100
    requiredAttr: true, // default is false
    controlSequenceKeys: ['NumLock', 'Clear'], // default is null
    callbackAfterTimeout: true // default is false
}
import VueGoodTablePlugin from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'

Vue.use(VueGoodTablePlugin);
Vue.use(VueBarcodeScanner, options);
Vue.component('vue-editor', VueEditor)
Vue.component('loading', Loading);
Vue.component('VueToggles', VueToggles);
Vue.use(VueVirtualScroller)
Vue.use(DrawerLayout);
Vue.component('v-select', vSelect)
Vue.config.productionTip = false;
(async () => {
    await migrateLegacyVuexState();
    new Vue({
        router,
        store,
        render: h => h(App),
        mounted() {
            // Start App Usage tracking - flushes events every 30 seconds
            startBatchTimer()
        }
    }).$mount('#app');

    // Initialize single-active-tab guard (leader election + overlay)
    try { initTabGuardLeader(); } catch (e) { /* no-op */ }
    if (navigator.storage && navigator.storage.persist) {
        const isPersistent = await navigator.storage.persisted();

        if (!isPersistent) {
            const granted = await navigator.storage.persist();
            if (granted) {
            } else {
            }
        }
    }
})();
